import { render, staticRenderFns } from "./CustomerDepositLimitManaged.vue?vue&type=template&id=1d413b0e&"
import script from "./CustomerDepositLimitManaged.vue?vue&type=script&lang=js&"
export * from "./CustomerDepositLimitManaged.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports